import { ShowMoreButton } from '../../../../ui/components/ShowMoreButton';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { getMissionStatusLabel } from '../../../../ui/utils/getMissionStatusLabel';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import React from 'react';
import { useMissionFilters } from '../../mission/hooks/useMissionFilters';
import { useMissionTab } from '../../mission/hooks/useMissionTab';
import { useMissions } from '../../mission/hooks/useMissions';
import { getMissionHeaderTitle } from '../utils/getMissionHeaderTitle';
import { EmptyMissionList } from './EmptyMissionList';
import { MissionBox } from './MissionBox';
import { MissionDetailsVolunteer } from './MissionDetailsVolunteer';
import { MissionListWrapper } from './MissionListWrapper';
import { MissionPageToolbar } from './MissionPageToolbar';
import { ShiftContainer } from './ShiftContainer';
export const MyMissions = () => {
    const { t } = useMissionsTranslation();
    const [displayMyMissions, setDisplayMyMissions] = React.useState(false);
    const { sortBy, clearFilters, onMissionsSortBy, applyFilter, activeFilters } = useMissionFilters();
    const { missionTab } = useMissionTab();
    const { requireAnySystemPermission } = usePermission();
    const allowMissionChange = requireAnySystemPermission('manage-missions', 'manage-all-admin-missions');
    const { loadMoreMissions, displayedMissions, isLoading, myTotalShiftsByMissionId } = useMissions({
        isVolunteerView: true,
        shouldCalculateMyMissions: true,
        displayMyMissions,
        sortBy,
        activeFilters,
    });
    const handleMissionParticipationFilter = () => {
        setDisplayMyMissions(!displayMyMissions);
    };
    const missionHeaderDescriptionId = React.useId();
    const missionDetailsDescriptionId = React.useId();
    if (isLoading) {
        return React.createElement(Typography, null, t('common.loading'));
    }
    return (React.createElement(Box, null,
        React.createElement(MissionPageToolbar, { onApplyFilter: applyFilter, onClearFilters: clearFilters, onSortBy: onMissionsSortBy, sortBy: sortBy, actions: React.createElement(FormControlLabel, { control: React.createElement(Switch, { onChange: () => {
                        handleMissionParticipationFilter();
                    } }), label: t('missions.volunteerMissions'), color: 'primary' }) }),
        React.createElement(MissionListWrapper, null,
            displayedMissions.total === 0 && React.createElement(EmptyMissionList, null),
            displayedMissions.total !== 0 && (React.createElement(React.Fragment, null,
                displayedMissions.rows.map((mission) => {
                    var _a;
                    const activeShifts = mission.shifts.rows.filter((shift) => shift.columns.stopTime > Date.now());
                    const hasActiveShifts = activeShifts.length > 0;
                    const linkToMissionDetails = `${mission.id}?missionTab=${missionTab}`;
                    return (React.createElement(MissionBox, { key: mission.id, missionId: mission.id, missionStatus: mission.columns.status, headerTitle: getMissionHeaderTitle(activeShifts, t), headerDescriptionId: missionHeaderDescriptionId, additionalHeaderInfo: React.createElement(Typography, { sx: { alignSelf: { xs: 'flex-end', sm: 'center' } }, variant: 'subtitle2', "data-test": 'mission-status' }, getMissionStatusLabel(t, mission.columns.status, allowMissionChange)) },
                        React.createElement(MissionDetailsVolunteer, { missionId: mission.id, missionName: mission.columns.name, missionType: mission.columns.type, missionStatus: mission.columns.status, descriptionId: `${missionHeaderDescriptionId} ${missionDetailsDescriptionId}`, detailsDescriptionId: missionDetailsDescriptionId, missionPlaceholdersDetails: {
                                myShifts: (_a = myTotalShiftsByMissionId[mission.id]) !== null && _a !== void 0 ? _a : 0,
                                upcomingAvailableShifts: activeShifts.length,
                            } }),
                        hasActiveShifts && (React.createElement(ShiftContainer, { shifts: activeShifts, linkToMissionDetails: linkToMissionDetails }))));
                }),
                displayedMissions.rows.length < displayedMissions.total && React.createElement(ShowMoreButton, { onLoadMore: loadMoreMissions }))))));
};
